define('modules/ads/ads_collection',['backbone', 'jquery', '_', 'session', './ad_model'], function (
  Backbone,
  $,
  _,
  session,
  AdModel
) {
  'use strict';
  var Collection = Backbone.Collection.extend({
    model: AdModel,

    metadata: {},

    default_params: {
      order_by: 'start_date',
      order: 'ASC',
      period: 'all',
    },

    params: {},

    initialize: function () {
      this.resetParams();
    },

    parse: function (response) {
      if (response.metadata) {
        this.metadata = _.extend(response.metadata);
        this.params = _.extend(this.params, response.metadata);
      }
      return response.data;
    },

    resetParams: function () {
      this.params = _.extend({}, this.default_params);
    },

    url: function () {
      return (
        session.get('apiUrl') + 'htmladlocations?' + $.param(this.params || {})
      );
    },
  });

  return Collection;
});

